<template>
  <div>
    <div id="Chart1" style="width: 100%; height: 250px"></div>
  </div>
</template>

<script>
export default {
  props:{
    data_x:{
      type:Array,
      default(){
        return []
      }
    },
    data_y:{
      type:Array,
      default(){
        return []
      }
    },
  },
  computed:{
  },
  methods: {
    myEcharts() {
      console.log(this);
      var myChart = this.$echarts.init(document.getElementById("Chart1"));
      //配置图表
      var option = {
        title: {
          text: "市场总览",
          left: 0,
          top: 3,
        },
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 0,
        },
        xAxis: {
          data: this.data_x,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },
          axisLabel: {
            formatter: function (value) {
              //value 为 data的每一项
              //这里会循环 data  return出的每一项会替换渲染对应的data
              return `{a|${value}}`;
            },
            rich: {
              //富文本样式设置
              a: {
                color: "#666",
              },
            },
          },
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        series: [
          {
            type: "bar",
            label: {
              formatter: "{c}",
              show: true,
              position: "top",
            },
             barWidth:32,
            data: this.data_y,
          },
        ],
      };
      myChart.setOption(option);
    },
  },
  mounted() {
    // this.myEcharts();
  },
};
</script>

<style scoped>
</style>